@let admin = isAdmin();
@let language = language$ | async;
@let isUserType = isIncluded(type(), [TemplateType.User]);
@let isUserOrBOType = isIncluded(type(), [TemplateType.User, TemplateType.UserBO]);
@let isUserBOType = isIncluded(type(), [TemplateType.UserBO]);
@if (userForm && formInputs) {
  <form class="bo-general-form" [class.bo-general-form--edit]="isEdit()" [formGroup]="userForm">
    <div class="p-grid p-justify-center p-align-center u-margin-bottom--lg">
      <div class="bo-general-form__avatar-wrapper p-col-fixed">
        <mcui-file-avatar
          [imageSource]="userData()?.avatarPath"
          [text]="userData()?.['name'] | firstCharacter: userData()?.['surname']"
          [backgroundColor]="defaultAvatarColor"
          (avatarChange)="onAvatarChange($event)"
        />
      </div>

      <div class="p-col">
        <bo-heading
          extraClasses="m-heading--md m-uppercase u-margin-bottom--lg"
          titleText="MTR_SUBTITLE_DETAILS"
        />
        <div class="p-grid">
          @for (
            inputKey of [
              'name',
              'surname',
              'active',
              'email',
              'customerId',
              'isPrincipalCustomerContact',
              'positionId',
              'language',
              'twoFactorEnabled',
              'phoneNumber',
            ];
            track inputKey
          ) {
            @if (formInputs[inputKey]) {
              <div
                class="p-col-12 bo-form__input-group"
                [class]="'p-md-' + (type() === TemplateType.UserProfile ? 6 : 4)"
              >
                <ng-container *ngTemplateOutlet="formInput; context: { inputKey: inputKey }" />
              </div>
            }
          }
        </div>
      </div>
    </div>

    @if (isUserType) {
      <bo-heading
        extraClasses="m-heading--md m-uppercase u-margin-bottom--lg"
        titleText="MTR_SUBTITLE_CATEGORY"
      />
      <div class="p-grid u-margin-bottom--lg">
        <div class="p-col-12 p-md-6 bo-form__input-group">
          <ng-container *ngTemplateOutlet="formInput; context: { inputKey: 'categoryId' }" />
        </div>
      </div>
    }
    @if (isUserOrBOType) {
      <bo-heading
        extraClasses="m-heading--md m-uppercase u-margin-bottom--lg"
        titleText="MTR_SUBTITLE_LICENSE"
      />
      <div class="p-grid u-margin-bottom--lg">
        <div class="p-col-12 p-md-6 bo-form__input-group">
          <ng-container
            *ngTemplateOutlet="formInput; context: { inputKey: 'passwordExpiration' }"
          />
        </div>
        @if (isUserType) {
          <div class="p-col-12 p-md-6 bo-form__input-group">
            <bo-button
              [text]="'MTR_COMMON_EXPIRE_PASSWORD'"
              (onClick)="onRevokePassword()"
              qaId="bo-user-revoke-password"
            />
          </div>
        }
      </div>
      <div class="p-grid u-margin-bottom--lg">
        <div class="p-col-12 p-md-6 bo-form__input-group">
          <ng-container *ngTemplateOutlet="formInput; context: { inputKey: 'activePeriodEnd' }" />
        </div>
        @if (isUserType) {
          <div class="p-col-12 p-md-6 bo-form__input-group">
            <bo-button
              [text]="'MTR_COMMON_RESEND_WELCOME_EMAIL'"
              (onClick)="onResendWelcomeEmail()"
              qaId="bo-user-resend-welcome-mail"
            />
          </div>
        }
      </div>
    }
    @if (isUserType) {
      <bo-heading
        extraClasses="m-heading--md m-uppercase u-margin-bottom--lg"
        titleText="MTR_SUBTITLE_APPLICATION_ACCESS"
      />
      <div class="p-grid u-margin-bottom--lg">
        <div class="p-col-12 bo-form__input-group">
          <ng-container *ngTemplateOutlet="formInput; context: { inputKey: 'profileIds' }" />
        </div>
      </div>
    }
    @if (isUserBOType) {
      <bo-heading
        extraClasses="m-heading--md m-uppercase u-margin-bottom--lg"
        titleText="MTR_SUBTITLE_BO_ROLES"
      />
      <div class="p-grid u-margin-bottom--lg">
        <div class="p-col-12 bo-form__input-group">
          <ng-container *ngTemplateOutlet="formInput; context: { inputKey: 'roleIds' }" />
        </div>
      </div>
    }

    <ng-template #formInput let-inputKey="inputKey">
      @let config = formInputs[inputKey];
      @let ctrl = userForm.get(inputKey);
      @let inputId = inputKey + uniqueIdPrefix;
      @if (config) {
        <label
          class="bo-form__input-label u-margin-bottom--sm"
          [class.bo-form__input--required]="
            isEdit() &&
            config.validators?.includes(VALIDATORS.required) &&
            !config.validators?.includes(VALIDATORS.email)
          "
          [for]="inputId"
          >{{ config.label | translate }}</label
        >

        @switch (config.type) {
          @case (InputType.Text) {
            <input
              pInputText
              class="bo-form__input"
              [id]="inputId"
              [formControlName]="inputKey"
              (keydown)="config.keyMask && config.keyMask($event)"
            />
          }
          @case (InputType.Dropdown) {
            @let options = (config.options | async) || [];
            @if (config.isGroup) {
              <bo-dropdown
                class="bo-form__input"
                [appendTo]="
                  type() === TemplateType.UserProfile && inputKey === 'language' ? 'body' : null
                "
                [inputId]="inputId"
                [showClear]="false"
                [group]="config.isGroup"
                [options]="options"
                [placeholder]="config.placeholder"
                [formControlName]="inputKey"
              />
            } @else {
              <mcui-select
                class="bo-form__input"
                [filterPlaceholder]="'MTR_COMMON_SEARCH' | translate"
                [filter]="true"
                [options]="options"
                [placeholder]="config.placeholder | translate"
                [formControlName]="inputKey"
                [optionSelectedTemplate]="$any(selectedTpl)"
                [optionTemplate]="$any(optionTpl)"
              >
                <ng-template #selectedTpl let-displayText="displayText">
                  {{ displayText | translate }}
                </ng-template>
                <ng-template #optionTpl let-item="item">
                  <span [translate]="item.label"></span>
                </ng-template>
              </mcui-select>
            }
          }
          @case (InputType.Switch) {
            <div class="bo-form__switch">
              <mcui-switch #mcuiSwitch [formControlName]="inputKey" />

              @if (config.switchLabels) {
                @let text = config.switchLabels[!mcuiSwitch.value ? 0 : 1]?.['text'];
                <span [class.is-disabled]="mcuiSwitch.disabled">{{ text | translate }}</span>
              } @else {
                <span [class.is-disabled]="mcuiSwitch.disabled">
                  {{ (mcuiSwitch.value ? 'MTR_COMMON_YES' : 'MTR_COMMON_NO') | translate }}
                </span>
              }
            </div>
          }
          @case (InputType.Calendar) {
            <bo-calendar
              class="bo-form__input"
              [inputId]="inputId"
              [showClear]="false"
              [yearRange]="config.yearRange"
              [placeholder]="config.placeholder"
              [formControlName]="inputKey"
              [language]="language"
            />
          }
          @case (InputType.SwitchMultiple) {
            @if (inputKey === 'profileIds') {
              <bo-application-access-table
                class="bo-form__input"
                [formControlName]="inputKey"
                [options]="(config.options | async) || []"
              />
            } @else {
              <p-selectButton
                class="bo-form__input"
                multiple="true"
                [id]="inputKey"
                [formControlName]="inputKey"
                (onOptionClick)="$event.option.checked = !$event.option.checked"
                [options]="config.options | async"
                #selectButtons
              >
                <ng-template let-item pTemplate>
                  <div class="bo-form__switch">
                    <mcui-switch
                      class="bo-form__input bo-form__input--inline"
                      [(ngModel)]="item.checked"
                      [ngModelOptions]="{ standalone: true }"
                      [disabled]="!!(selectButtons.disabled() || item.disabled)"
                      [pTooltip]="
                        shouldDisableOption(item.value, admin)
                          ? ('MTR_COMMON_ONLY_ADMIN_EDIT' | translate)
                          : false
                      "
                    />
                    <span [class.is-disabled]="!!(selectButtons.disabled() || item.disabled)">
                      {{ item.label | translate }}
                    </span>
                  </div>
                </ng-template>
              </p-selectButton>
            }
          }
        }
        @if (ctrl?.hasError('required') && config.validators?.includes(VALIDATORS.required)) {
          <span class="bo-form__input-error">
            {{ 'MTR_COMMON_ERROR_FIELD_REQUIRED' | translate }}
          </span>
        }
        @if (ctrl?.hasError('email') && config.validators?.includes(VALIDATORS.email)) {
          <span class="bo-form__input-error">
            {{ 'MTR_COMMON_ERROR_EMAIL_INVALID' | translate }}
          </span>
        }
        @if (ctrl?.hasError('atLeast') && config.validators?.includes(VALIDATORS.atLeastOne)) {
          <span class="bo-form__input-error">
            {{ 'MTR_COMMON_ERROR_AT_LEAST_ONE' | translate }}
          </span>
        }
      }
    </ng-template>
  </form>
}
